import type { BookingListRow } from "./bookingViewModel";

/** People / seats for a booking — same for every activity type. */
export function bookingPartyCount(row: BookingListRow): number {
  if (row.peopleCount != null) return row.peopleCount;
  if (row.lineItems.length > 0) {
    return row.lineItems.reduce((sum, item) => sum + item.quantity, 0);
  }
  return row.quantity ?? 0;
}
